import { Button } from '#app/components/Buttons/Button.js';
import { type ButtonVariant } from '#app/components/Buttons/types.js';
import {
  CloseIconButton,
  DrawerBody,
  DrawerFooter,
  DrawerScreen,
  DrawerWrapper,
} from './SlideUpDrawer.styles.js';
import { CloseIcon } from '@contra/icons/icons';
import { FocusScope } from '@react-aria/focus';
import { OverlayContainer } from '@react-aria/overlays';
import { forwardRef, type ReactNode, type Ref } from 'react';

type DrawerProps = {
  readonly buttonVariant?: ButtonVariant;
  readonly children: ReactNode;
  readonly closeButtonLabel?: string;
  readonly darkMode?: boolean;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly removeCloseButton?: boolean;
  readonly removePaddingOnMobile?: boolean;
  readonly topCloseButton?: boolean;
};

export const SlideUpDrawer = forwardRef(
  (
    {
      buttonVariant = 'V2TertiaryOutline',
      children,
      closeButtonLabel = 'Close',
      isOpen,
      onClose,
      removeCloseButton = false,
      removePaddingOnMobile = false,
      topCloseButton = false,
      ...drawerProps
    }: DrawerProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <>
        {isOpen && (
          <OverlayContainer>
            <FocusScope
              autoFocus
              contain
              restoreFocus
            >
              <DrawerScreen />
              <DrawerWrapper
                ref={ref}
                removePaddingOnMobile={removePaddingOnMobile}
                role="dialog"
                {...drawerProps}
              >
                {topCloseButton ? (
                  <CloseIconButton onClick={onClose}>
                    <CloseIcon size={16} />
                  </CloseIconButton>
                ) : null}
                <DrawerBody>{children}</DrawerBody>
                {topCloseButton || removeCloseButton ? null : (
                  <DrawerFooter>
                    <Button
                      onClick={(event: {
                        preventDefault: () => void;
                        stopPropagation: () => void;
                      }) => {
                        event.preventDefault();
                        /* stop propagation to avoid the click event
       on the NotificationLayout.Link component to be triggered */
                        event.stopPropagation();
                        onClose();
                      }}
                      role="button"
                      variant={buttonVariant}
                    >
                      {closeButtonLabel}
                    </Button>
                  </DrawerFooter>
                )}
              </DrawerWrapper>
            </FocusScope>
          </OverlayContainer>
        )}
      </>
    );
  },
);
